import { UAContext } from '@quentin-sommer/react-useragent';
import React, { useContext } from 'react';
import { useThemeContext } from '~components/theme-provider';
import Typography from '~components/typography';
import { useTranslation } from '~i18n';
import { NoBooked } from '~svg-components';

const BookingProgressCard: React.FC = props => {
  const uaResults = useContext(UAContext).uaResults as UAResults;
  const isMobile = uaResults.mobile;
  const { t } = useTranslation();
  const { ORG } = useThemeContext();

  return (
    <div className="no-booked">
      <NoBooked width={isMobile ? 240 : 400} height={isMobile ? 186 : 311} />
      <Typography component="div" variant={isMobile ? 'h7' : 'h2'} className="no-booked__title">
        {t('no_properties_booked')}
      </Typography>
      <Typography component="div" variant={isMobile ? 'body3' : 'body2'}>
        {t(`no_properties_booked.find_now.${ORG}`)}
      </Typography>
      <style jsx>{`
        .no-booked {
          padding: 100px 0;
          text-align: center;
          :global(&__title) {
            margin-top: 70px;
            margin-bottom: 12px;
          }
          :global(&__btn) {
            margin-top: 48px;
          }
        }
        @media screen and (max-width: 768px) {
          .no-booked {
            padding: 57px 0 68px;
            :global(&__title) {
              margin-top: 50px;
              margin-bottom: 8px;
            }
            :global(&__btn) {
              margin-top: 32px;
            }
          }
        }
      `}</style>
    </div>
  );
};

export default BookingProgressCard;
